import { useEffect, useState } from 'react';
import axios from '../../config/axios';
import { getApiUrl } from '../../config/environment';

export interface DentalProfessionalOption {
  id: string;
  full_name: string;
  specialty?: string | null;
}

/**
 * Profissionais ativos para atribuição de lançamentos e tratamentos.
 * Só busca quando o formulário está aberto, para não custar request em abas
 * que nunca são usadas.
 */
export function useDentalProfessionals(enabled: boolean): DentalProfessionalOption[] {
  const [professionals, setProfessionals] = useState<DentalProfessionalOption[]>([]);

  useEffect(() => {
    if (!enabled) return;
    let cancelled = false;
    axios
      .get(getApiUrl('/clinic/professionals'), { params: { is_active: true, limit: 200 } })
      .then((res) => {
        if (cancelled) return;
        const list = Array.isArray(res.data?.data) ? res.data.data : res.data || [];
        setProfessionals(list.filter((p: any) => p?.is_active !== false));
      })
      .catch(() => {
        if (!cancelled) setProfessionals([]);
      });
    return () => { cancelled = true; };
  }, [enabled]);

  return professionals;
}

export function todayIso(): string {
  return new Date().toISOString().slice(0, 10);
}

export function formatDateBr(value?: string | null): string {
  if (!value) return '—';
  const date = new Date(`${value.slice(0, 10)}T12:00:00`);
  return Number.isNaN(date.getTime()) ? '—' : date.toLocaleDateString('pt-BR');
}

export function formatCurrencyBr(value?: number | null): string {
  return (Number(value) || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
}
